import { useQuery } from "@tanstack/react-query";
import { emptyPage, Page, TrainingHistory } from "@/model";
import deploymentRepository from "@/repository/deploymentRepository";


const getData = async (id: number, page: number, size: number) => {
    const res = await deploymentRepository.findTrainingHistory(id, page, size);
    return res.data?.data || emptyPage<TrainingHistory>();
};

export const usePaginatedTrainingHistories = (agentId: number, page: number, size: number) => {
    return useQuery<Page<TrainingHistory>>({
        queryKey: ["training-history-page", agentId, "page", page, "size", size],
        queryFn: async () => getData(agentId, page, size),
        retry: false
    });
};
